import googleSrc from '@corbado/shared-ui/assets/google.svg';
import React from 'react';
import { Icon } from './Icon';
export const GoogleIcon = props => {
    return (React.createElement(Icon, { src: googleSrc, ...props }));
};
export default GoogleIcon;
